import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const ticketService = {
    fetchTicket: async ({ token, pagina = 1, pageSize = 20, desde, hasta, estado, tipo, nombre }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/tickets/all'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, estado, tipo, nombre },
            });

            return {
                tickets: response.data.tickets || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en ticketService.fetchTicket:', error);
            throw error;
        }
    },
    getEstadoTicket: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/tickets/estados'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estados;
        } catch (error) {
            console.error('Error en getEstadoTicket:', error);
            throw error;
        }
    },
    getTiposSolicitud: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/tickets/tiposolicitud'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.tipoSolicitud;
        } catch (error) {
            console.error('Error en getTiposSolicitud:', error);
            throw error;
        }
    },
    exportarSolicitudesExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/tickets/exportarAll'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ticketService.exportarSolicitudesExcel:', error);
            throw error;
        }
    },
    guardarTipoSolicitud: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await axios.put(
                    buildApiUrl(`/api/tickets/tiposolicitud/${editingItem.id}`),
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await axios.post(buildApiUrl('/api/tickets/tiposolicitud'), formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en ticketService.guardarSolicitudes:', error);
            throw error;
        }
    },
    getTicketById: async (token, id) => {
        try {
            const response = await axios.get(
                buildApiUrl(`/api/tickets/${id}/agent`),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error en getTicketById:', error);
            throw error;
        }
    },
    getMessageByTicket: async (token, id) => {
        try {
            const response = await axios.get(
                buildApiUrl(`/api/tickets/message/${id}`),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error en getMessageByTicket:', error);
            throw error;
        }
    },
    marcarMensajesComoLeidos: async (token, ticketId, sender_type = 'user') => {
        try {
            const response = await axios.post(
                buildApiUrl(`/api/tickets/message/marcar-leidos/${ticketId}`),
                {
                    sender_type: sender_type,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Error en marcarMensajesComoLeidos:', error);
            throw error;
        }
    },
    atenderTicket: async (token, ticketId) => {
        try {
            await axios.get(
                buildApiUrl(`/api/tickets/${ticketId}/atender`),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
        } catch (error) {
            console.error('Error en ticketService.atenderTicket:', error);
            throw error;
        }
    },
    sendMessage: async (token, ticketId, payload, sender_type = 'agent') => {
        try {
            let data = {};
            let headers = { Authorization: `Bearer ${token}` };
            if (payload instanceof FormData) {
                data = payload;
            } else {
                data = {
                    message: payload,
                    sender_type: sender_type,
                };
            }

            await axios.post(
                buildApiUrl(`/api/tickets/${ticketId}/messages`),
                data,
                {
                    headers: headers,
                }
            );
        } catch (error) {
            console.error('Error en ticketService.sendMessage:', error);
            throw error;
        }
    },
    cerrarTicket: async (token, ticketId) => {
        await axios.get(buildApiUrl(`/api/tickets/${ticketId}/cerrar`), {
            headers: { Authorization: `Bearer ${token}` },
        });
    },
    exportarTicket: async (token, ticketId) => {
        try {
            const response = await axios.post(buildApiUrl(`/api/tickets/${ticketId}/exportar`), {}, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ticketService.exportarTicket:', error);
            throw error;
        }
    },
    getTicketMessageNoLeido: async ({ token }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/tickets/messagesnoleidos'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return {
                tickets: response.data.tickets || [],
            };
        } catch (error) {
            console.error('Error en ticketService.getTicketMessageNoLeido:', error);
            throw error;
        }
    },
};
